import widgetModule, { infoIconStyles } from "@stoneage/App/Widgets/InfoIcon/InfoIcon";
import { css } from "styled-components";

infoIconStyles.leftWrapper = {
    css: css`
        ${infoIconStyles.leftWrapper?.css};
        margin-right: 32px;

        height: 80px;
        width: 80px;
        min-height: 80px;
        min-width: 80px;

        &&& {
            img {
                height: 80px;
                width: 80px;
                overflow: hidden;
                object-fit: contain;
            }
        }
    `,
};

export * from "@stoneage/App/Widgets/Welcome/Welcome";
export default widgetModule;
